/** @format */

import { AfterViewInit, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { BookingDataService } from "../../services/booking-data.service";
import { ConfigurationService } from "../../services/configuration.service";
import { EmpUserService } from "../../services/emp-user.service";
import { HomeDataService } from "../../services/home-data.service";
import { PreferenceDataService } from "../../services/preference-data.service";
import { CookieService } from "../../services/cookie.service";
import { Subscription } from "rxjs";

@Component({
  selector: "mis-employee-web-exp-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"]
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() empGuid: string;
  @Input() buid: string;
  showTeamCalendar = false;
  private _zedaEnabled: boolean = false;
  empInfoSubscription$: Subscription;

  constructor(
    private _cookieService: CookieService,
    private user: EmpUserService,
    public configSvc: ConfigurationService,
    private homeSvc: HomeDataService,
    private preferenceSvc: PreferenceDataService,
    private bookingSvc: BookingDataService
  ) {}

  ngOnInit(): void {
    if (!this.empGuid || !this.buid) {
      throw new Error("missing required inputs buid & empGUid");
    }
    this._zedaEnabled = this._cookieService.getCookie("zedaEnabled") == "true";
    this.user.setUser(this.buid, this.empGuid);
    this.configSvc.refreshReplayStreams();
    this.homeSvc.refreshReplayStreams();
    // this.preferenceSvc.refreshReplayStreams({startTime: moment().valueOf().toString(), buid: this.buid, empguid: this.empGuid,});
    this.bookingSvc.refreshReplayStreams();
  }
  ngAfterViewInit(): void {
    this.empInfoSubscription$ = this.homeSvc.employeeInfo.subscribe(empInfo => {
      if (this._zedaEnabled && empInfo?.email && empInfo?.name) (<any>window)?.zeda?.init({ email: empInfo.email, name: empInfo.name });
    });
  }
  ngOnDestroy(): void {
    if (this._zedaEnabled) (<any>window)?.zeda?.remove();
    if (this.empInfoSubscription$) this.empInfoSubscription$.unsubscribe();
  }

  openTeamCalendar(): void {
    this.showTeamCalendar = true;
  }

  closeTeamCalendar(): void {
    this.showTeamCalendar = false;
  }
}
